import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { Experiments, useExperiment } from 'apps-common/utils/experiments';

import { routes } from '../routes';
import { useStore } from '../store';

export const useRedirectPrepaidPendingUser = (isUserInactivePrepaidPending: boolean) => {
  const inactivePrepaidPendingExperiment = useExperiment(
    Experiments.INACTIVE_PREPAID_PENDING_WELCOME_MOMENT,
  ).experiment.get('showWelcomeMoment');

  const navigate = useNavigate();
  const hasViewedAnimatedSpotlight = useStore((state) => state.hasViewedAnimatedSpotlight);
  const setHasViewedAnimatedSpotlight = useStore((state) => state.setHasViewedAnimatedSpotlight);

  useEffect(() => {
    if (!inactivePrepaidPendingExperiment) return;
    if (hasViewedAnimatedSpotlight) return;
    if (!isUserInactivePrepaidPending) return;

    setHasViewedAnimatedSpotlight(true);
    navigate(routes.renewInactiveMembership);
  }, [
    hasViewedAnimatedSpotlight,
    inactivePrepaidPendingExperiment,
    isUserInactivePrepaidPending,
    navigate,
    setHasViewedAnimatedSpotlight,
  ]);
};
